import React from 'react';

interface CustomJournalEventProps {
    fill?: string;
}

export const CustomJournalEvent = ({ fill }: CustomJournalEventProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="18" height="18" rx="9" fill="#9DA1AC" />
        <g clipPath="url(#clip0_816_11912)">
            <path
                d="M12.138 6.66667H10.6667V5.19533L12.138 6.66667ZM12.3334 7.33333V13H5.66669V6C5.66669 5.73478 5.77204 5.48043 5.95958 5.29289C6.14712 5.10536 6.40147 5 6.66669 5H10V7.33333H12.3334ZM7.33335 10.3333H9.66669V9.66667H7.33335V10.3333ZM10.6667 11H7.33335V11.6667H10.6667V11ZM10.6667 8.33333H7.33335V9H10.6667V8.33333Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_816_11912">
                <rect width="8" height="8" fill="white" transform="translate(5 5)" />
            </clipPath>
        </defs>
    </svg>
);
